/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Deploy_Title6Inputs */

const en_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production deploy`)
};

const ar_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشر إنتاجي`)
};

const bn_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশন ডিপ্লয়`)
};

const de_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktionsbereitstellung`)
};

const es_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Despliegue de producción`)
};

const fr_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement en production`)
};

const pt_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantação de produção`)
};

const zh_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产部署`)
};

const tr_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim dağıtımı`)
};

const ru_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочее развертывание`)
};

const pl_svc_mvp_sprint_deploy_title6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie produkcyjne`)
};

/**
* | output |
* | --- |
* | "Production deploy" |
*
* @param {Svc_Mvp_Sprint_Deploy_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_deploy_title6 = /** @type {((inputs?: Svc_Mvp_Sprint_Deploy_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Deploy_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "de") return de_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "es") return es_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_deploy_title6(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_deploy_title6(inputs)
	return en_svc_mvp_sprint_deploy_title6(inputs)
});
export { svc_mvp_sprint_deploy_title6 as "svc_mvp-sprint_DEPLOY_title" }